import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function EmployeeProtectedRoute({ children }) {
  const token = localStorage.getItem('employee_access_token');
  const location = useLocation();
  if (!token) {
    return <Navigate to="/employee/login" state={{ from: location.pathname }} replace />;
  }
  return children;
} 